import InvoiceSummary from '../../pages/Invoice/InvoiceSummary';
import { InvoiceController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { invoiceStore } from '../../stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const InvoiceSummaryContainer = ({
	closeModal,
	editInvoiceMain,
	setShowSurvey,
}) => {
	const [editInvoice, setEditInvoice] = useState(false);
	const [updateInvoice, setUpdateInvoice] = useState(false);

	const goToEditInvoice = () => {
		setEditInvoice(true);
	};
	const goToUpdateInvoice = () => {
		setUpdateInvoice(true);
	};

	const invoice = invoiceStore.selectedInvoice;
	const invoiceItem = invoice.status === constant.TRANSACTION_STATUS.UNPAID;

	const sendInvoice = async id => {
		const { status, errorMessage } = await InvoiceController.sendInvoice(id);
		if (status === constant.Success) {
			return MimaToastUtil.success({
				message: constant.Sent,
			});
		}
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};
	const onDownload = async (invoiceId) => {
		const { errorMessage } = await InvoiceController.download(invoiceId);
		if(errorMessage){
			MimaToastUtil.error({
				message: errorMessage,
			});
		}else {
			MimaToastUtil.success({
				message: constant.Success,
			});
		}
	};
	const updatedCloseModal =()=> {
		closeModal();
		setEditInvoice(false);
		setUpdateInvoice(false);
	}

	return (
		<InvoiceSummary
			onDownload={onDownload}
			sendInvoice={sendInvoice}
			editInvoice={editInvoice}
			goToEditInvoice={goToEditInvoice}
			editInvoiceMain={editInvoiceMain}
			closeModal={updatedCloseModal}
			updateInvoice={updateInvoice}
			goToUpdateInvoice={goToUpdateInvoice}
			invoiceItem={invoiceItem}
			setShowSurvey={setShowSurvey}
		/>
	);
};

export default observer(InvoiceSummaryContainer);
